import * as React from "react";
import clsx from "clsx";
import {makeStyles} from "@mui/styles";

export type InfoStepProps = {
   icon: string,
   children: React.ReactNode | React.ReactNode[] | null;
}

export const InfoStep = (props: InfoStepProps) => {
   const classes = useStyles();

   return <div className={classes.step}>
      <div className={clsx(classes.vstep, "c2s-infostep-icon")}>
         <div className={classes.circle}>
            <div className={classes.centerContent}>
               {props.icon.startsWith('http') ?
                  <img src={props.icon} className={classes.icon} alt={props.icon}/>
                  : props.icon}
            </div>
         </div>
         <div className={classes.line}>&nbsp;</div>
      </div>
      <div className={clsx(classes.content, "c2s-infostep-details")}>
         {props.children}
      </div>
   </div>
}

const useStyles = makeStyles({
   step: {
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'flex-start',
      boxSizing: 'border-box',
      paddingBottom: '30px'
   },
   vstep: {
      display: 'flex',
      flexDirection: 'column'
   },
   circle: {
      border: '3px solid #e0e0e0',
      borderRadius: '100%',
      width: '48px',
      height: '48px',
      display: 'inline-block',
      boxSizing: 'border-box'
   },
   line: {
      height: '100%',
      borderLeft: '3px solid #e0e0e0',
      marginLeft: '22px'
   },
   content: {
      marginTop: '13px',
      marginLeft: '20px',
      display: 'inline-block'
   },
   centerContent: {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      height: '42px',
      width: '42px',
      minWidth: 0,
      overflow: 'hidden'
   },
   icon: {
      width: '29px',
      alignSelf: 'initial !important'
   }
});